import { ConvexHttpClient } from 'convex/browser';
import { ConvexReactClient } from 'convex/react';
import { makeFunctionReference } from 'convex/server';

const convexUrl = import.meta.env.VITE_CONVEX_URL;

export const hasConvexClient = Boolean(convexUrl);
export const convexReactClient = convexUrl ? new ConvexReactClient(convexUrl) : null;

function createHttpClient(token?: string | null) {
  if (!convexUrl) {
    return null;
  }
  const client = new ConvexHttpClient(convexUrl);
  if (token) {
    client.setAuth(token);
  }
  return client;
}

export async function runConvexQuery<T>(name: string, args: Record<string, unknown>, token?: string | null) {
  const client = createHttpClient(token);
  if (!client) {
    return null;
  }
  return client.query(makeFunctionReference<'query', Record<string, unknown>, T>(name), args);
}

export async function runConvexMutation<T>(name: string, args: Record<string, unknown>, token?: string | null) {
  const client = createHttpClient(token);
  if (!client) {
    return null;
  }
  return client.mutation(makeFunctionReference<'mutation', Record<string, unknown>, T>(name), args);
}

export async function runConvexAction<T>(name: string, args: Record<string, unknown>, token?: string | null) {
  const client = createHttpClient(token);
  if (!client) {
    return null;
  }
  return client.action(makeFunctionReference<'action', Record<string, unknown>, T>(name), args);
}
